import React from "react";
import "style.css";
import "tailwindcss/lib/css/preflight.css";

function NotFound() {
    return (
      <h1>Not Found</h1>
    )
}

export default NotFound